import { useLazyQuery } from "@apollo/client/react"; import moment from 'moment';
import 'moment/locale/es';
import { useEffect, useState } from 'react';
import './documentsDetailContent.scss';
import { useLocation } from 'react-router-dom';
import { Checkbox, Grid } from '@mui/material';
import { CustomButton } from '../../../components/customButton/CustomButton';
import toast from 'react-hot-toast';
import { GET_DOCUMENTO_DETALLE } from '../../../data/graphQL/queries/Documentos/getDocumentoDetalle';

import DocumentViewer from '../../../components/DocumentViewer';
import fileDownload from 'js-file-download';
import { GET_CUMPLIMIENTO_EVALUACION, adaptCumplimiento } from '../../../data/graphQL/queries/Documentos/getCumplimientoEvaluacion';

export const DocumentsDetailContent = ({ setChildrenAction }) => {
  const { state } = useLocation();

  const { data, filters } = state;

  const [fileToView, setFileToView] = useState(null);
  const [cumplimientoProfesionales, setCumplimientoProfesionales] = useState(null);

  const [openDlg, setOpenDlg] = useState(false);
  const [loadingPrint, setLoadingPrint] = useState(false);

  const handleViewCheck = (value) => {
    return value == "S" || value == "O";
  };

  const [tipoArchivo, setTipoArchivo] = useState({
    AC: handleViewCheck(data?.aC),
    C: handleViewCheck(data?.c),
    PE: handleViewCheck(data?.pE),
    EV: handleViewCheck(data?.eV),
    RNH: handleViewCheck(data?.rNH),
    RFK: handleViewCheck(data?.rFK),
    P: handleViewCheck(data?.p),
    V: handleViewCheck(data?.v),
    DOC: handleViewCheck(data?.dOC),
    PG: handleViewCheck(data?.pG),
    NT: handleViewCheck(data?.nT),
    FN: handleViewCheck(data?.fN),
    PS: handleViewCheck(data?.pS),
    KN: handleViewCheck(data?.kN),
    TOC: handleViewCheck(data?.tOC),
    ASS: handleViewCheck(data?.aSS),
    RCP: handleViewCheck(data?.rCP),
    PSI: handleViewCheck(data?.pSI)
  });

  const [getCumplimientoEvaluacion, { data: dataCumplimiento }] = useLazyQuery(GET_CUMPLIMIENTO_EVALUACION, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!dataCumplimiento) return;
    setCumplimientoProfesionales(adaptCumplimiento(dataCumplimiento?.calcularPorcentajeCumplimiento));
  }, [dataCumplimiento]);

  useEffect(() => {
    if (!data?.idEvaluacion) return;
    getCumplimientoEvaluacion({ variables: { idEvaluacion: data?.idEvaluacion, from: moment(filters?.fechaDesde), to: moment(filters?.fechaHasta) } });
  }, [data]);

  useEffect(() => {
    setChildrenAction(() =>
      <div className='documentos-all'>
        <CustomButton
          className='margin-right'
          onClick={handlePrint}
          isLoading={loadingPrint}>

          Imprimir
        </CustomButton>
      </div>
    );
  }, [setChildrenAction, tipoArchivo, loadingPrint]);

  // compone el string con los tipos de archivos a consultar de acuerdo a los checks
  const handlePrint = () => {
    let cadena = '';
    if (tipoArchivo.AC) {
      cadena += '-AC-';
    }
    if (tipoArchivo.C) {
      cadena += '-C-';
    }
    if (tipoArchivo.PE) {
      cadena += '-PE-';
    }
    if (tipoArchivo.EV) {
        cadena += '-EV-';
    }
    if (tipoArchivo.RNH) {
      cadena += '-RNH-';
    }
    if (tipoArchivo.RFK) {
      cadena += '-RFK-';
    }
    if (tipoArchivo.P) {
      cadena += '-P-';
    }
    if (tipoArchivo.V) {
      cadena += '-V-';
    }
    if (tipoArchivo.DOC) {
      cadena += '-DOC-';
    }
    if (tipoArchivo.CU) {
      cadena += '-CU-';
    }
    if (tipoArchivo.PG) {
      cadena += '-PG-';
    }
    if (tipoArchivo.NT) {
      cadena += '-NT-';
    }
    if (tipoArchivo.FN) {
      cadena += '-FN-';
    }
    if (tipoArchivo.PS) {
      cadena += '-PS-';
    }
    if (tipoArchivo.KN) {
      cadena += '-KN-';
    }
    if (tipoArchivo.TOC) {
      cadena += '-TOC-';
    }
    if (tipoArchivo.ASS) {
      cadena += '-ASS-';
    }
    if (tipoArchivo.PSI) {
      cadena += '-PSI-';
    }

    if (cadena == '') {
      toast.error("Debe seleccionar al menos un documento.");
    } else {
      // imprimir
      setLoadingPrint(true);
      getDetalle({
        variables: {
          idEvaluacion: data?.idEvaluacion,
          fechaDesde: moment(filters?.fechaDesde).format("yyyy-MM-DD"),
          fechaHasta: moment(filters?.fechaHasta).format("yyyy-MM-DD"),
          documentos: cadena
        }
      });
    }
  };
  const handleChangeTipoArchivo = (e) => {
    const { name, checked } = e.target;
    setTipoArchivo((prevDatos) => ({
      ...prevDatos,
      [name]: checked
    }));
  };

  useEffect(() => {
    if (fileToView != null) {
      setOpenDlg(true);
    }
  }, [fileToView]);

  const [getDetalle, { data: detalleData, loading: detalleLoading }] = useLazyQuery(GET_DOCUMENTO_DETALLE, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!detalleData) return;
    if (detalleData.documentosDetalle.valorEsperado != null) {
      const arr = new Uint8Array(detalleData.documentosDetalle.valorEsperado);
      const documento = new Blob([arr], { type: 'application/pdf' });
      const fileName = data.idEvaluacion + '.pdf';

      fileDownload(documento, fileName);
    } else {
      setFileToView(null);
      toast.error("No fue posible obtener los documentos para generar el PDF general.");
    }
    setLoadingPrint(false);
  }, [detalleData]);


  return (
    <>
      <div className='card-container' style={{ margin: '-10px' }}>
        <Grid
          container
          justifyContent={'space-between'}
          rowGap={1}>

          <Grid size={{ md: 1 }}>
            <strong>Evaluación</strong>
            <br></br>
            <label>{data.idEvaluacion}</label>
          </Grid>
          <Grid size={{ md: 2.5 }}>
            <strong>Paciente</strong>
            <br></br>
            <label>{data.paciente}</label>
          </Grid>
          <Grid size={{ md: 3 }}>
            <strong>Cliente</strong>
            <br></br>
            <label>{data.cliente}</label>
          </Grid>
          <Grid size={{ md: 1 }}>
            <strong>Fecha desde</strong>
            <br></br>
            <label>{moment(data.fechaDesde).format('DD/MM/yyyy')}</label>
          </Grid>

          <Grid size={{ md: 1 }}>
            <strong>Fecha hasta</strong>
            <br></br>
            <label>{moment(data.fechaHasta).format('DD/MM/yyyy')}</label>
          </Grid>
          <Grid size={{ md: 2.5 }}>
            <strong>Módulo</strong>
            <br></br>
            <label>{data.modulo}</label>
          </Grid>
        </Grid>
      </div>
      <br />
      {/* Documentos */}
      <div className='card-container' style={{ margin: '-10px', marginTop: '10px' }}>
        <Grid
          container
          justifyContent={'flex-start'}>

          <Grid size={{ md: 12 }}>
            <div className='titulo-seccion'>Documentos</div>
          </Grid>
          <Grid size={{ md: 2 }}>
            <Checkbox
              checked={tipoArchivo.ASS}
              disabled={!handleViewCheck(data?.aSS)}
              name="ASS"
              onChange={handleChangeTipoArchivo}
              className='chk-documento'
            />
            Asistente Social {(cumplimientoProfesionales?.AS !== null && cumplimientoProfesionales?.AS !== undefined) && `- ${cumplimientoProfesionales?.AS}%`}
          </Grid>
          <Grid size={{ md: 2 }}>
            <Checkbox
              checked={tipoArchivo.AC}
              disabled={!handleViewCheck(data?.aC)}
              name="AC"
              onChange={handleChangeTipoArchivo}
              className='chk-documento' />

            Autorizaciones
          </Grid>
          <Grid size={{ md: 2 }}>
            <Checkbox
              checked={tipoArchivo.C}
              disabled={!handleViewCheck(data?.c)}
              name="C"
              onChange={handleChangeTipoArchivo}
              className='chk-documento' />

            Conformidades
          </Grid>
          <Grid size={{ md: 2 }}>
            <Checkbox
              checked={tipoArchivo.DOC}
              disabled={!handleViewCheck(data?.dOC)}
              name="DOC"
              onChange={handleChangeTipoArchivo}
              className='chk-documento' />

            Documentación Paciente
          </Grid>
          <Grid size={{ md: 2 }}>
            <Checkbox
              checked={tipoArchivo.PE}
              disabled={!handleViewCheck(data?.pE)}
              name="PE"
              onChange={handleChangeTipoArchivo}
              className='chk-documento'
            />
            Enfermería {(cumplimientoProfesionales?.EN !== null && cumplimientoProfesionales?.EN !== undefined)
              && `- ${cumplimientoProfesionales?.EN}%`}
          </Grid>
          <Grid size={{ md: 2 }}>
            <Checkbox
              checked={tipoArchivo.PG}
              disabled={!handleViewCheck(data?.pG)}
              name="PG"
              onChange={handleChangeTipoArchivo}
              className='chk-documento'
            />
            Enfermería Guardia CP {(cumplimientoProfesionales?.EG !== null && cumplimientoProfesionales?.EG !== undefined)
              && `- ${cumplimientoProfesionales?.EG}%`}
          </Grid>
          <Grid size={{ md: 2 }}>
            <Checkbox
              checked={tipoArchivo.EV}
              disabled={!handleViewCheck(data?.eV)}
              name="EV"
              onChange={handleChangeTipoArchivo}
              className='chk-documento'
            />
            Ev. Mensual {![13, 16].includes(data.idTipoModulo)
              && (cumplimientoProfesionales?.ME !== null && cumplimientoProfesionales?.ME !== undefined)
              && `- ${cumplimientoProfesionales?.ME}%`}
          </Grid>
          <Grid size={{ md: 2 }}>
            <Checkbox
              checked={tipoArchivo.FN}
              disabled={!handleViewCheck(data?.fN)}
              name="FN"
              onChange={handleChangeTipoArchivo}
              className='chk-documento'
            />
            Fonoaudiólogo {(cumplimientoProfesionales?.FO !== null && cumplimientoProfesionales?.FO !== undefined)
              && `- ${cumplimientoProfesionales?.FO}%`}
          </Grid>
          <Grid size={{ md: 2 }}>
            <Checkbox
              checked={tipoArchivo.KN}
              disabled={!handleViewCheck(data?.kN)}
              name="KN"
              onChange={handleChangeTipoArchivo}
              className='chk-documento'
            />
            Kinesiólogo {(cumplimientoProfesionales?.KN !== null && cumplimientoProfesionales?.KN !== undefined)
              && `- ${cumplimientoProfesionales?.KN}%`}
          </Grid>
          <Grid size={{ md: 2 }}>
            <Checkbox
              checked={tipoArchivo.NT}
              disabled={!handleViewCheck(data?.nT)}
              name="NT"
              onChange={handleChangeTipoArchivo}
              className='chk-documento'
            />
            Nutricionista {(cumplimientoProfesionales?.NU !== null && cumplimientoProfesionales?.NU !== undefined)
              && `- ${cumplimientoProfesionales?.NU}%`}
          </Grid>
          <Grid size={{ md: 2 }}>
            <Checkbox
              checked={tipoArchivo.P}
              disabled={!handleViewCheck(data?.p)}
              name="P"
              onChange={handleChangeTipoArchivo}
              className='chk-documento' />

            Prescripción
          </Grid>
          <Grid size={{ md: 2 }}>
            <Checkbox
              checked={tipoArchivo.PS}
              disabled={!handleViewCheck(data?.pS)}
              name="PS"
              onChange={handleChangeTipoArchivo}
              className='chk-documento'
            />
            Psicólogo {(cumplimientoProfesionales?.PS !== null && cumplimientoProfesionales?.PS !== undefined)
              && `- ${cumplimientoProfesionales?.PS}%`}
          </Grid>
          <Grid size={{ md: 2 }}>
            <Checkbox
              checked={tipoArchivo.PSI}
              disabled={!handleViewCheck(data?.pSI)}
              name="PSI"
              onChange={handleChangeTipoArchivo}
              className='chk-documento'
            />
            Psiquiatra {(cumplimientoProfesionales?.PI !== null && cumplimientoProfesionales?.PI !== undefined)
              && `- ${cumplimientoProfesionales?.PI}%`}
          </Grid>
          <Grid size={{ md: 2 }}>
            <Checkbox
              checked={tipoArchivo.RFK}
              disabled={!handleViewCheck(data?.rFK)}
              name="RFK"
              onChange={handleChangeTipoArchivo}
              className='chk-documento' />

            Remito FK
          </Grid>
          <Grid size={{ md: 2 }}>
            <Checkbox
              checked={tipoArchivo.RNH}
              disabled={!handleViewCheck(data?.rNH)}
              name="RNH"
              onChange={handleChangeTipoArchivo}
              className='chk-documento' />

            Remito NH
          </Grid>
          <Grid size={{ md: 2 }}>
            <Checkbox
              checked={tipoArchivo.TOC}
              disabled={!handleViewCheck(data?.tOC)}
              name="TOC"
              onChange={handleChangeTipoArchivo}
              className='chk-documento'
            />
            Terapista Ocupacional {(cumplimientoProfesionales?.TO !== null && cumplimientoProfesionales?.TO !== undefined)
              && `- ${cumplimientoProfesionales?.TO}%`}
          </Grid>
          <Grid size={{ md: 2 }}>
            <Checkbox
              checked={tipoArchivo.V}
              disabled={!handleViewCheck(data?.v)}
              name="V"
              onChange={handleChangeTipoArchivo}
              className='chk-documento' />

            Validación
          </Grid>
        </Grid>
      </div>

      {openDlg && <DocumentViewer data={fileToView} setOpenDlg={setOpenDlg} width='lg' download={true} />}
    </>);

};